import React, { Component } from 'react';
import ImageModule from './Module/Image';
import AudioModule from './Module/Audio';
import DownloadModule from './Module/Download';
import TextModule from './Module/Text';
import SlideshowModule from './Module/Slideshow';
import TaskModule from './Module/Task';
import DiscussionModule from './Module/Discussion';
import VideoModule from './Module/Video';
import * as MaterialIcons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';
import shallowEqual from 'shallowequal';
import { pageModules } from 'Constants';
import NewVideoModule from 'module/View/VideoModule';
import EmbedModule from 'module/View/EmbedModule';
import WebinarModule from './Module/Webinar';
import QuizIframeModule from './Module/QuizIframe';
import analytics from 'helpers/universalAnalytics';

const Modules = {
  image: ImageModule,
  audio: AudioModule,
  download: DownloadModule,
  text: TextModule,
  slideshow: SlideshowModule,
  task: TaskModule,
  discussion: DiscussionModule,
  video: VideoModule,
  webinar: WebinarModule,
  quiziframe: QuizIframeModule,
};

var options = {
  default: {},
  Audio: {
    menuItems: {
      default: [
        {
          menu: 'edit',
          icon: <MaterialIcons.ContentCreate color={Colors.Colors.fullWhite} />
        }
      ],
      edit: [
        {
          onTouchTap: 'save',
          icon: <MaterialIcons.ActionDone color={Colors.Colors.fullWhite} />
        },
        {
          onTouchTap: 'cancel',
          icon: <MaterialIcons.ContentClear color={Colors.Colors.fullWhite} />
        },
        {
          onTouchTap: 'delete',
          icon: <MaterialIcons.ActionDelete color={Colors.Colors.fullWhite} />
        }
      ],
      settings: [
        {
          onTouchTap: 'settings',
          icon: <MaterialIcons.ActionSettings color={Colors.Colors.fullWhite} />
        },
        {
          menu: 'default',
          icon: <MaterialIcons.ContentClear color={Colors.Colors.fullWhite} />
        }
      ]
    }
  },
  Video: {
    menuItems: {
      default: [
        // {menu: 'settings', icon: 'cog'},
        {
          menu: 'edit',
          icon: <MaterialIcons.ContentCreate color={Colors.Colors.fullWhite} />
        }
      ],
      edit: [
        {
          onTouchTap: 'save',
          icon: <MaterialIcons.ActionDone color={Colors.Colors.fullWhite} />
        },
        {
          onTouchTap: 'cancel',
          icon: <MaterialIcons.ContentClear color={Colors.Colors.fullWhite} />
        },
        {
          onTouchTap: 'delete',
          icon: <MaterialIcons.ActionDelete color={Colors.Colors.fullWhite} />
        }
      ],
      settings: [
        {
          onTouchTap: 'settings',
          icon: <MaterialIcons.ActionSettings color={Colors.Colors.fullWhite} />
        },
        {
          menu: 'default',
          icon: <MaterialIcons.ContentClear color={Colors.Colors.fullWhite} />
        }
      ]
    }
  },
  Image: {
    menuItems: {
      default: [
        {
          menu: 'edit',
          icon: <MaterialIcons.ContentCreate color={Colors.Colors.fullWhite} />
        }
      ],
      edit: [
        {
          onTouchTap: 'save',
          icon: <MaterialIcons.ActionDone color={Colors.Colors.fullWhite} />
        },
        {
          onTouchTap: 'cancel',
          icon: <MaterialIcons.ContentClear color={Colors.Colors.fullWhite} />
        },
        {
          onTouchTap: 'delete',
          icon: <MaterialIcons.ActionDelete color={Colors.Colors.fullWhite} />
        }
      ]
    }
  },
  Download: {
    menuItems: {
      default: [
        {
          menu: 'edit',
          icon: <MaterialIcons.ContentCreate color={Colors.Colors.fullWhite} />
        }
      ],
      edit: [
        {
          onTouchTap: 'save',
          icon: <MaterialIcons.ActionDone color={Colors.Colors.fullWhite} />
        },
        {
          onTouchTap: 'cancel',
          icon: <MaterialIcons.ContentClear color={Colors.Colors.fullWhite} />
        },
        {
          onTouchTap: 'delete',
          icon: <MaterialIcons.ActionDelete color={Colors.Colors.fullWhite} />
        }
      ]
    }
  },
  Slideshow: {
    menuItems: {
      default: [
        // {menu: 'settings', icon: 'cog'},
        {
          menu: 'edit',
          icon: <MaterialIcons.ContentCreate color={Colors.Colors.fullWhite} />
        }
      ],
      edit: [
        {
          onTouchTap: 'save',
          icon: <MaterialIcons.ActionDone color={Colors.Colors.fullWhite} />
        },
        {
          onTouchTap: 'cancel',
          icon: <MaterialIcons.ContentClear color={Colors.Colors.fullWhite} />
        },
        {
          onTouchTap: 'delete',
          icon: <MaterialIcons.ActionDelete color={Colors.Colors.fullWhite} />
        }
        // {onTouchTap: 'deleteImage', icon : <MaterialIcons.ActionDelete color={Colors.Colors.fullWhite} />},
        // {onTouchTap: 'mediaLibrary', icon : <MaterialIcons.ImagePhotoLibrary color={Colors.Colors.fullWhite} />},
      ],
      settings: [
        {
          onTouchTap: 'settings',
          icon: <MaterialIcons.ActionSettings color={Colors.Colors.fullWhite} />
        },
        {
          menu: 'default',
          icon: <MaterialIcons.ContentClear color={Colors.Colors.fullWhite} />
        }
      ]
    }
  }
};



export default class Column extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqual(this.props, nextProps);
  }

  trackInteraction = () => {

    let typeId = this.props.data.type.id;
    let name = null;
    Object.keys(pageModules).forEach(moduleName => {
      if (pageModules[moduleName].id === typeId) {
        name = moduleName;
      }
    });
    if(name) {
      analytics.event(this.props.courseId, `${name}_interaction`, { eventLabel: this.props.pageId });
    }
  };

  render() {

    let type = this.props.data.type;
    let Module;
    let ModuleName;
    let className;
    if (type.name) {
      const name = type.name;
      if (name === '!video') {
        const { editor, saving, data } = this.props;
        const { sources, caption } = data.data;
        const { id, mode } = data;
        return (
          <NewVideoModule
            editor={editor}
            saving={saving}
            id={id}
            caption={caption}
            sources={sources}
            mode={mode}
          />
        );
      } else if (name === 'embed') {
        const { editor, saving, data } = this.props;
        const { sources, caption } = data.data;
        const { id, mode } = data;
        return (
          <EmbedModule
            editor={editor}
            saving={saving}
            id={id}
            sources={sources || []}
            caption={caption}
            mode={mode}
          />
        );
      } else {
        className = 'page-module ' + type.name + '-module ' + this.props.columnClass;
        Module = Modules[name];
        ModuleName = name;
      }
    } else {

      className = 'page-module';
      Object.keys(pageModules).forEach(moduleName => {
        if (pageModules[moduleName].id === type.id) {

          Module = Modules[moduleName];
          ModuleName = moduleName;
        }
      });
    }
    if (Module) {
      const { mode, saving } = this.props.data;

      return (
        <Module
          themeColor={this.props.themeColor}
          data={this.props.data.data}
          {...this.props.data.data}
          isQuiz={this.props.isQuiz}
          saving={saving}
          name={type.name}
          user={this.props.user}
          editor={this.props.editor}
          reader={this.props.reader}
          moduleId={this.props.data.id}
          pageId={this.props.pageId}
          courseId={this.props.courseId}
          courseSlug={this.props.courseSlug}
          ownerName={this.props.ownerName}
          gaTracking={this.trackInteraction}
          pageRowId={this.props.pageRowId}
          mode={mode}
          defaultMenu={mode}
          className={className}
          moduleName={ModuleName}
        />
      );
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Page/Column.js